<template>
	<Card>
		<StrapiList source="/campaigns" :query="{ archived: false }">
			<template v-slot="list">
				<CampaignsTable v-bind="list" />
			</template>
		</StrapiList>
	</Card>
</template>

<script>
import Card from '@/components/shared/Card'
import StrapiList from '@/components/admin/StrapiList'
import CampaignsTable from '@/components/admin/CampaignsTable'

export default {
	name: 'ManageCampaigns',
	components: {
		Card,
		StrapiList,
		CampaignsTable
	}
}
</script>
